<template>
<svg width="11" height="22" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M4.90723 3.81494H7.88086V5.09668H4.90723V8.46582H3.54492V5.09668H0.571289V3.81494H3.54492V0.702148H4.90723V3.81494Z" fill="currentColor"/>
</svg>
</template>

<script>
export default {
  name: 'icon-plus'
}
</script>